import { PagedTable } from 'bold-ui'
import { TableBox } from 'components/table/TableBox'
import { usePagination } from 'components/table/usePagination'
import React from 'react'

import { MedicoesPreNatal } from '../../types/model-historicoPreNatal'
import { MedicaoAntropometricaPreNatal } from './model-medicoesPreNatal'
import { getColumnsTableItens, getMedicaoForImcReferencia } from './util-medicoesPreNatal'

interface MedicoesPreNatalTableProps {
  items: MedicoesPreNatal[]
  dataInicioGestacao: Date
  medicoesAntropometricasPreNatal: MedicaoAntropometricaPreNatal[]
  isIgEcografica: boolean
  showLabelIgRegistradoAgora?: boolean
  loading?: boolean
  showPressaoArterial?: boolean
}

export function MedicoesPreNatalTable(props: MedicoesPreNatalTableProps) {
  const {
    items,
    dataInicioGestacao,
    medicoesAntropometricasPreNatal,
    isIgEcografica,
    showLabelIgRegistradoAgora,
    loading,
    showPressaoArterial = false,
  } = props

  const medicaoForImcReferencia = getMedicaoForImcReferencia(dataInicioGestacao, medicoesAntropometricasPreNatal)

  const { paginatedItems, tableProps: propsPagination } = usePagination({
    items: items,
  })
  const { pageSize, ...propsPaginationToPagedTable } = propsPagination

  const tableProps = {
    ...propsPaginationToPagedTable,
    size: pageSize,
    rows: paginatedItems,
  }

  const columns = getColumnsTableItens(
    dataInicioGestacao,
    isIgEcografica,
    showLabelIgRegistradoAgora,
    medicaoForImcReferencia?.peso,
    showPressaoArterial
  )

  return (
    <TableBox>
      <PagedTable<MedicoesPreNatal> {...tableProps} columns={columns} loading={loading} />
    </TableBox>
  )
}
